import * as React from "react";
import type { SVGProps } from "react";
const SvgTag = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M16.354 7.652h-.006m3.175-4.8-5.8-.447a1.77 1.77 0 0 0-1.386.512l-9.42 9.42c-.69.69-.69 1.809 0 2.499l6.247 6.246c.69.69 1.809.69 2.499 0l9.42-9.42c.364-.364.551-.87.512-1.384l-.446-5.8a1.77 1.77 0 0 0-1.626-1.627"
    />
  </svg>
);
export default SvgTag;
